import React from "react";
import { Link } from "react-router";

const labels = {
  members: "Members",
  resources: "Resources",
  notifications: "Notifications",
  webinars: "Webinars",
  cpd: "CPD",
  chat: "Chat",
  faqs: "FAQs",
  statistics: "Statistics",
};
const url = {
  members: "/members",
  resources: "/course-materials",
  notifications: "/notifications",
  webinars: "/webinars",
  cpd: "/cpd",
  chat: "/chat",
  faqs: "/faqs",
  statistics: "/statistics",
};

const MenuSwitch = ({ tabs, groupId, activeUrl }) => {
  const generateUrl = (url) => `/groups/${groupId}${url}`;

  return (
    <div className="group-tabs-container">
      {tabs.map((tab, index) => (
        <Link
          to={generateUrl(url[tab])}
          key={`tab${index}`}
          className={`button_classic ${
            activeUrl.match(url[tab]) ? "active" : ""
          }`}
        >
          {labels[tab]}
        </Link>
      ))}
    </div>
  );
};

export default MenuSwitch;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/MenuSwitch.jsx